var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "custom-multiselect-style placeholder-italic" },
    [
      _c("multiselect", {
        attrs: {
          options: _vm.availabilityOptions,
          placeholder: "Assign priority",
          searchable: false,
          "show-no-results": false,
          openDirection: _vm.below,
          taggable: false,
          showLabels: false,
          "show-labels": false,
        },
        on: { input: _vm.updateSelection, change: _vm.updateSelection },
        scopedSlots: _vm._u([
          {
            key: "option",
            fn: function ({ option }) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "multiselect-option flex flex-row gap-2 justify-flex-start items-center",
                  },
                  [
                    option === "High"
                      ? [_c("High", { staticClass: "w-6 h-6" })]
                      : option === "Highest"
                      ? [_c("Highest")]
                      : option === "Low"
                      ? [_c("Low")]
                      : option === "Lowest"
                      ? [_c("Lowest")]
                      : [_c("Medium")],
                    _c("span", [_vm._v(_vm._s(option))]),
                  ],
                  2
                ),
              ]
            },
          },
          {
            key: "selected",
            fn: function ({ option }) {
              return [
                _c(
                  "div",
                  {
                    staticClass:
                      "multiselect-option flex flex-row gap-2 justify-flex-start items-center",
                  },
                  [
                    option === "High"
                      ? [_c("High", { staticClass: "w-6 h-6" })]
                      : option === "Highest"
                      ? [_c("Highest")]
                      : option === "Low"
                      ? [_c("Low")]
                      : option === "Lowest"
                      ? [_c("Lowest")]
                      : [_c("Medium")],
                    _c("span", [_vm._v(_vm._s(option))]),
                  ],
                  2
                ),
              ]
            },
          },
        ]),
        model: {
          value: _vm.selectedOption,
          callback: function ($$v) {
            _vm.selectedOption = $$v
          },
          expression: "selectedOption",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }